export const PageSize =
{
  Size: 100
}
